module.exports = __webpack_public_path__ + "static/media/058-myanmar.56145926.svg";